// extracted by mini-css-extract-plugin
export default {"root":"smarty-tabs-module--root--50e61","pill":"smarty-tabs-module--pill--feb54","pillActive":"smarty-tabs-module--pillActive--951c9","tabs":"smarty-tabs-module--tabs--45c3b"};